@use "@fukuri-admins/ui/layout" as *;

.clickable {
  cursor: pointer;

  &:hover {
    background-color: background('Senary');
  }
}
